<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.8682 20.1471L13.7344 10L27.2896 23.8971L30.8682 20.1471Z"
      :fill="clr"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1084 10.1113C12 10.2216 12 10.3319 12 10.5525V39.229C12 39.3393 12 39.4496 12.1084 39.4496L26.4228 24.6701L12.1084 10.1113Z"
      :fill="clr"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.2908 25.5508L13.1934 39.9993C13.2221 39.9993 13.2497 39.9877 13.27 39.967C13.2904 39.9463 13.3018 39.9183 13.3018 39.889L31.0863 29.4111L27.2908 25.5508Z"
      :fill="clr"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.5926 24.1174L31.9537 20.8086L28.1582 24.7792L32.1705 28.9704L37.5926 25.7718C37.7192 25.6757 37.822 25.5509 37.8927 25.4073C37.9635 25.2637 38.0004 25.1053 38.0004 24.9446C38.0004 24.784 37.9635 24.6256 37.8927 24.482C37.822 24.3383 37.7192 24.2135 37.5926 24.1174Z"
      :fill="clr"
    />
    <rect x="0.5" y="0.5" width="49" height="49" rx="3.5" :stroke="clr" />
  </svg>
</template>
